import { createContext } from "react";

export const themeState = {
  theme: 'base',
};

export const ThemeContext = createContext(themeState.theme);